import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Ana', 'Sofía', 'Valentina', 'Isabella', 'Camila', 'Lucía', 'Mariana', 'Gabriela', 'Daniela'];
const LOCATIONS = ['Buenos Aires, Argentina', 'Santiago, Chile', 'Bogotá, Colombia', 'Ciudad de México, México', 'Lima, Perú', 'Medellín, Colombia', 'Córdoba, Argentina', 'Guadalajara, México', 'Montevideo, Uruguay', 'Quito, Ecuador'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 4000);
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      setData({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (random between 8-12 seconds + 4s display time)
      const nextDelay = Math.random() * 4000 + 8000 + 4000;
      setTimeout(showPopup, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-xs w-full animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-119">
      <div className="bg-white rounded-lg shadow-lg p-4 border-l-4 border-green-500 flex items-start gap-3" data-id="element-120">
        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-121">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-122" />
        </div>
        <div data-id="element-123">
          <p className="text-sm font-medium text-gray-900" data-id="element-124">
            <span className="font-bold" data-id="element-125">{data.name}</span> de {data.location}
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-126">
            acaba de comprar Desinflamada en 7 Días™
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-127">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}